import React from "react";
import { resource } from "@app/common/localization/resource";
import { Layout } from "@app/common/components/Layout";
import { StepNumber } from "@app/common/components/StepNumber";
import { useDocumentTitle } from "@app/common/hooks/useDocumentTitle";
import { StyledRegisterPage } from "./RegisterPage.styles";

export const RegisterPage: React.VFC = () => {
  useDocumentTitle(resource("common.registerTitle"));

  const stepItem = (index: number) => (
    <div className="step" key={index}>
      <StepNumber number={index} />
      <div className="step-text">
        <h3>{resource(`landing.step${index}Title`)}</h3>
        <p>{resource(`landing.step${index}Description`)}</p>
      </div>
    </div>
  );

  return (
    <Layout>
      <StyledRegisterPage>
        <h1 className="pageHeader">{resource("landing.registerPageTitle")}</h1>
        <div className="card">
          <h2>{resource("landing.registerTitle")}</h2>
          <p className="lead">{resource("landing.registerDescription")}</p>
          {stepItem(1)}
          {stepItem(2)}
          {stepItem(3)}
        </div>
      </StyledRegisterPage>
    </Layout>
  );
};
